module.exports = __webpack_public_path__ + "img/school.0d165fab.svg";